'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var UPGRADE_DATA_INVALID = exports.UPGRADE_DATA_INVALID = false;
var UPGRADE_DATA_VALID = exports.UPGRADE_DATA_VALID = true;


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/ui-addon-upgrades/static-9.1086/js/_core/common/data/upgradeData/upgradeDataStates.js
// module id = 274
// module chunks = 3 4 5